/*
 * @Author: zhu.huijun
 * @Date: 2021-05-07 10:05:18
 * @Last Modified by: zhu.huijun
 * @Last Modified time: 2022-02-17 14:07:17
 */
// Select Number 逻辑
// 条件1、主套餐的 attrCode 为 EXP_ACCESS_TYPE 且对应的 defaultValue 值为 COPPER（铜网） ，
// 条件2、comboUnit 的 servType 为 LANDLINE(26)、BROADBAND(79)、BB_VPN_NODE(903),
// 在条件1和条件2同时满足的情况下，只有 comboUnit 的 servType 为 LANDLINE(26) 下的套餐需要选择手机号，servType 为 BROADBAND(79)、BB_VPN_NODE(903)的手机号值与 LANDLINE(26) 保持一致, 且 input禁用
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { i18n } from 'fishx';
import isEmpty from 'lodash/isEmpty';

import { Form, Input, Button, Pagination, Row, Col, Select, Spin } from '@whalecloud/fdx';
import CommonModal from '@/components/CommonModal';
import { ApplyType } from '@/utils';
import { formItemLayout, NumberRuleGroup, NumberRuleKeys, NumberStateOpt, NbrOperType } from './utils';

import styles from './index.module.less';

const NumberSelect = props => {
  const numberInput = useRef();
  const {
    loading = false,
    disabled = false, // 是否禁用
    addressId, // 调用创建客户地址接口成功后返回的 custAddressId 字段
    exchangeId,
    stdCode,
    subsServiceType, // 主产品id（service sub type）
    applyType = ApplyType.NEW, // 号码选择场景
    placeholder = i18n('COMMON_SELECT_ICON'),
    form,
    value = {}, // 号码数据 是Object
    numberList,
    pageInfo,
    accNbrClassList,
    onChange,
    qryAccNbrClass, // 查询号码等级
    qryAvailableAccNbrList, // 查询号码列表
    operAccNbr, // 号码预占和解锁
    onModalOpen, // 方法，用来在打开弹框前处理逻辑，返回 true/false
    ...preProps
  } = props;

  const { getFieldDecorator, getFieldsValue, resetFields } = form;
  const [visible, setVisible] = useState(false); // 弹框显示
  const [selectedNumber, setNumber] = useState({}); // 选中的账号
  const [searchInfo, setSearchInfo] = useState({}); // 查询条件
  const handleSearchNumberList = async page => {
    const params = {
      addressId,
      exchangeId,
      stdCode,
      applyType,
      indepProdSpecId: subsServiceType,
      pageReqDto: {
        currentPage: 1,
        pageSize: pageInfo.pageSize,
        ...page,
      },
      ...searchInfo,
    };
    await qryAvailableAccNbrList(params);

  };

  useEffect(() => {
    if (!isEmpty(stdCode) && !isEmpty(value) && !isEmpty(value.accNbr) && !value.accNbr.startsWith(stdCode + '-')) {
      onChange({});
      setNumber({});
      setVisible(false);
      setSearchInfo({});
    }
  }, [stdCode]);

  useEffect(() => {
    if (visible) { // 打开弹框查询数据
      qryAccNbrClass(); // 查询号码等级
    } else {
      handleSearchInfoChange(true);
    }
  }, [visible]);

  useEffect(() => {
    if (!visible) {
      numberInput.current.blur();
    }
  }, [visible]);

  useEffect(() => { // searchInfo 改变，查询数据
    if (visible) {
      handleSearchNumberList(); // 查询账号列表数据
    }
  }, [searchInfo, visible]);

  const handleNumberSelect = num => { // 选择账号
    const numDisabled = NumberStateOpt[num.accNbrState];
    if (numDisabled) {
      return;
    }
    setNumber(num);
  };

  const handleSearchInfoChange = async isReset => { // 存储
    const searchParams = {};
    if (isReset) {
      resetFields();
    } else {
      const { accNbrClass, rule, search } = getFieldsValue();
      // searchParams.accNbrClassList = accNbrClass ? accNbrClass.toString() : '';
      if (accNbrClass) {
        searchParams.accNbrClassList = accNbrClass.toString();
      }
      if (rule && search) {
        searchParams[rule] = search;
      }
    }
    setSearchInfo(searchParams);
  };

  // 分页页数变化
  const handlePageInfoChange = page => {
    handleSearchNumberList({
      currentPage: page,
    });
  };

  // 提交按钮
  const handleSubmit = async () => {
    // 通过 accNbrId 判断，二次业务首次选号不需要对旧号码进行解锁操作
    if (!isEmpty(value) && value.accNbrId && (JSON.stringify(value) !== JSON.stringify(selectedNumber))) {
      // 先解锁 二次业务重新选中号码，旧号码不需要解锁
      const unLockNbrInfo = {
        accNbrId: value.accNbrId,
        operType: NbrOperType.UN_LOCKED,
      };
      await operAccNbr(unLockNbrInfo);
    }
    // 再预占
    const lockNbrInfo = {
      accNbrId: selectedNumber.accNbrId,
      operType: NbrOperType.LOCKED,
    };
    operAccNbr(lockNbrInfo).then(isSuccess => {
      if (isSuccess) {
        onChange(selectedNumber);
        setVisible(false);
      }
    });
  };
  const handleInputClick = () => {
    if (disabled) {
      return;
    }
    if (onModalOpen) {
      const result = onModalOpen();
      setVisible(result);
      return;
    }
    setVisible(true);
  };

  const renderNumberBox = num => (
    <Col
      key={num.accNbrId}
      span={5}
      onClick={() => handleNumberSelect(num)}
    >
      <div title={num.accNbr} className={`${styles.numberBox} ${num.accNbrId === selectedNumber.accNbrId && styles.select}`}>
        <span className={styles.label}>{num.accNbr}</span>
        {num.accNbrId === selectedNumber.accNbrId && (
          <div className={styles.selectIcon}>
            <span className="iconfont2 iconcheck" />
          </div>
        )}
      </div>
    </Col>
  );

  return (
    <>
      <Input
        placeholder={placeholder}
        ref={numberInput}
        value={value?value.accNbr:null}
        disabled={disabled}
        onClick={handleInputClick}
        autoComplete="off"
        suffix={<span className="iconfont2 iconsend" style={{ color: '#ABACB2' }} onClick={handleInputClick} />}
        {...preProps}
      />
      {visible && (
        <CommonModal
          modalOpts={{
            title: i18n('SELECT_NUMBER_MODAL_TITLE'),
            footer: null,
            draggable: false,
            onCancel: () => setVisible(false),
            width: 800,
            className: styles.numberSelectModal,
          }}
        >
          <div>
            <Form layout="inline" {...formItemLayout}>
              {/* 选择规则 */}
              <Form.Item label={i18n('SELECT_NUMBER_MODAL_NUMBER_RULE')}>
                {getFieldDecorator('rule', {
                  initialValue: NumberRuleKeys.PREFIX,
                })(
                  <Select style={{ width: '100%' }} placeholder={i18n('COMMON_SELECT_ICON')}>
                    {NumberRuleGroup.map(rule => (
                      <Select.Option value={rule.value} key={rule.value}>
                        {i18n(rule.label)}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              {/* 搜索号码 */}
              <Form.Item label={i18n('SELECT_NUMBER_MODAL_LABEL_SEARCH')}>
                {getFieldDecorator('search', {
                })(<Input placeholder={i18n('PLEASE_INPUT')} />)}
              </Form.Item>
              {/* 号码等级 */}
              <Form.Item label={i18n('SELECT_NUMBER_MODAL_LEVEL')}>
                {getFieldDecorator('accNbrClass', {
                })(
                  <Select mode="multiple" style={{ width: '100%' }} placeholder={i18n('COMMON_SELECT_ICON')}>
                    {accNbrClassList.map(item => (
                      <Select.Option value={item.accNbrClassId} key={item.accNbrClassId}>
                        {item.accNbrClassName}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              {/* 按钮 */}
              <Form.Item className={styles.searchBtn} label="">
                <Button type="primary" onClick={() => handleSearchInfoChange()}>{i18n('BTN_QUERY')}</Button>
                <Button onClick={() => handleSearchInfoChange(true)}>{i18n('BTN_RESET')}</Button>
              </Form.Item>
            </Form>
            <Spin spinning={loading}>
              <div className={styles.numberGroup}>
                {
                  !isEmpty(value) && (
                    <Row style={{ marginLeft: 0, marginRight: 0 }}>
                      {renderNumberBox(value)}
                    </Row>
                  )
                }
                <Row style={{ marginLeft: 0, marginRight: 0 }}>
                  {numberList.map(num => renderNumberBox(num))}
                </Row>
                <div className={styles.pagination}>
                  <Pagination
                    showQuickJumper
                    total={pageInfo.total}
                    current={pageInfo.currentPage}
                    pageSize={pageInfo.pageSize}
                    onChange={handlePageInfoChange}
                  />
                </div>
              </div>
            </Spin>
            <div className={styles.footer}>
              <Button type="primary" onClick={handleSubmit} disabled={isEmpty(selectedNumber) || (value && selectedNumber.accNbr === value.accNbr)}>
                {i18n('COMMON_SUBMIT')}
              </Button>
            </div>
          </div>
        </CommonModal>
      )}
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  qryAvailableAccNbrList: payload =>
    dispatch({
      type: 'numberSelect/qryAvailableAccNbrList',
      payload,
    }),
  qryAccNbrClass: payload =>
    dispatch({
      type: 'numberSelect/qryAccNbrClass',
      payload,
    }),
  operAccNbr: payload =>
    dispatch({
      type: 'numberSelect/operAccNbr',
      payload,
    }),
});

export default connect(
  ({ numberSelect, loading }) => ({
    loading: loading.effects['numberSelect/qryAvailableAccNbrList'] || loading.effects['numberSelect/qryAccNbrClass'],
    numberList: numberSelect.numberList,
    pageInfo: numberSelect.pageInfo || {},
    accNbrClassList: numberSelect.accNbrClassList,
  }),
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(Form.create()(NumberSelect));
